import * as Library from '../../../core/library/index';
import { Product } from './product';
export class ProductPayment {


  /*
  {
      "vehicleType": "New", //"New" or "CPO" or "Used"
      "transactionType":"Retail", //"Retail" or "Lease" or "Cash"
      "monthlyPayment":245, //Only for retail or lease
      "term":24, //Only for retail or lease
      "totalDownPayment":3000, //Only for retail
      "apr":1.00, //Only for retail
      "annualMiles":12000, //Only for lease
      "dueAtSigning":450, //Only for lease
      "securityDeposit":500, //Only for lease
      "vehicleSellingPrice":23400, //Only for cash
      "totalEstimatedNetAmountDue":25000, //Only for cash
      "products":[
         {
            "productId":"VSA",
            "planId":"TFS Gold",
            "displayName":"VSA TFS Gold",
            "timeMileage":"8yr/80k",
            "deductible":"100",
            "customerPrice":2000,
            "monthlyPayment":35
         },
         {
            "productId":"TW",
            "planId":"Platinum Plus",
            "displayName":"TW Platinum Plus",
            "timeMileage":"8y/80k",
            "deductible":"100",
            "customerPrice":2000,
            "monthlyPayment":35
         }
      ]
   }
  */
  //Products

  public products:Product[];
  //vehicle Type
  public vehicleType: any;
  //Common for lease and finance
  public transactionType:any;
  public term:any;

  public monthlyPayment:any;
  public totalDownPayment:any;
  public apr:any;
  
  ///Below Fields for lease
  public dueAtSigning:any;
  public annualMiles:any;
  public securityDeposit:any;
  //Below Fields for Cash
  public vehicleSellingPrice:any;
  public totalEstimatedNetAmountDue:any;

  //
  // Constructor
  //
  constructor();
  constructor(payment: object);
  constructor(payment?: any) {
    this.transactionType = Library.init(payment, 'transactionType',"");
    this.totalDownPayment = Library.init(payment, 'totalDownPayment',"");
    this.term = Library.init(payment, 'term',"");
    this.apr = Library.init(payment, 'apr',"");
    this.monthlyPayment = Library.init(payment, 'monthlyPayment',"");
    this.vehicleSellingPrice = Library.init(payment, 'vehicleSellingPrice',"");
    this.vehicleType = Library.init(payment, 'vehicleType',"");

    this.dueAtSigning = Library.init(payment, 'dueAtSigning',"");
    this.annualMiles = Library.init(payment, 'annualMiles',"");
    this.securityDeposit = Library.init(payment, 'securityDeposit',"");
    this.totalEstimatedNetAmountDue = Library.init(payment, 'totalEstimatedNetAmountDue',"");
    this.products = Library.init(payment, 'products',[]);
  }
} 
